<template>
    <div class="search-listing flight-listing">
      <div class="flex-items">
        <div class="details-col">
          <div class="details-container">

            <div class="itinerary" v-for="(bound, boundIndex) in listing.bounds" :key="boundIndex">
              <div class="segment">
                
                <div class="airline">
                    <img 
                    class="airline-logo" 
                    :src="'https://assets.totaltravel.io/img/airlines/' + bound.segments[0].marketingCarrier.iataCode + '.png'"
                    :alt="bound.segments[0].marketingCarrier.iataCode | toAirlineName" />
                    
                </div>

                <div class="destination">
                  <p class="airport">
                    <i class="fal fa-plane-departure"></i>
                    {{bound.segments[0].from.iataCode | toCityName }} <span class="airport-code">{{ bound.segments[0].from.iataCode }}</span>
                    <!-- <span v-if="bound.segments[0].from.iataCode !== searchOrigin">Don't Match</span> -->
                  </p>
                  <p class="date-time">
                    {{ [ bound.segments[0].from.time, "HH:mm" ] | moment("h:mma") }}
                    <span>{{ bound.segments[0].from.date |  moment("ddd, MMM Do") }}</span>
                  </p>
                </div>

                <div class="duration">
                  <p>{{ bound.totalTravelTime | parseDuration }}</p>
                  <p v-if="bound.segments.length > 1">
                    {{bound.segments.length - 1}} Stop<span v-if="(bound.segments.length - 1) > 1">s</span>
                    <span class="stops">
                      (<span 
                        v-if="segmentIndex < bound.segments.length - 1" 
                        v-for="(segment, segmentIndex) in bound.segments" 
                        :key="segmentIndex"
                        class="stop">{{segment.to.iataCode}}</span>)</span>
                  </p>

                  <p v-else>{{ $t('nonStop') }}</p>
                </div>

                <div class="destination">
                  <p class="airport">
                    <i class="fal fa-plane-arrival"></i>
                    {{ bound.segments[bound.segments.length - 1].to.iataCode | toCityName }} <span class="airport-code">{{ bound.segments[bound.segments.length - 1].to.iataCode }}</span>
                  </p>
                  <p class="date-time">
                    {{ [ bound.segments[bound.segments.length - 1].to.time, "HH:mm" ] | moment("h:mma") }}
                    <span>{{ bound.segments[bound.segments.length - 1].to.date | moment("ddd, MMM Do") }}</span>
                  </p>
                </div>
              </div>

              <div class="round-trip-separator" v-if="boundIndex < listing.bounds.length - 1">
                <span>{{$t('daysInLocation', {days: departureToReturnDays, location: toCityName(bound.segments[bound.segments.length - 1].to.iataCode)})}}</span>
                <!-- <span>{{departureToReturnDays}} Days in {{bound.segments[bound.segments.length - 1].to.iataCode | toCityName}}</span> -->
              </div>
            </div>
          </div>
        </div>

        <div class="price-col">
            
            <div class="listing-icons">
              <v-popover
                offset="10"
                trigger="hover"
                placement="left"
              >
                <button class="icon tooltip-target">
                  <i class="fal fa-suitcase"></i>
                  <span v-if="listing.cabinBaggageTotal">{{ listing.cabinBaggageTotal }}</span>
                  <span v-else>0</span>
                </button>

                <button class="icon">
                  <i class="fal fa-suitcase-rolling"></i>
                  <span v-if="listing.checkedBaggageTotal">{{ listing.checkedBaggageTotal }}</span>
                  <span v-else>0</span>
                </button>

                <template slot="popover">
                  <div class="price-breakdown-popover">
                    <h5>{{$t('priceBreakdown')}}</h5>

                    <div class="summary-item">
                      <p class="label">
                        <i class="fal fa-plane-alt"></i>
                        {{$t('ticketPrice')}} ({{ listing.travelerPrices.length }})
                      </p>
                      <p class="value">
                        {{ listing.price.total | formatCurrency(currency, 0) }}
                      </p>
                    </div>

                    <div class="summary-item">
                      <p class="label">
                        <i class="fal fa-suitcase"></i>
                        {{$t('carryOnBag')}}
                        <span v-if="listing.cabinBaggageTotal > 0">({{ listing.cabinBaggageTotal }})</span>
                      </p>
                      <p class="value">
                        <span v-if="listing.cabinBaggageTotal > 0">{{$t('included')}}</span>
                        <span v-else>{{$t('addAtBook')}}</span>
                      </p>
                    </div>

                    <div class="summary-item">
                      <p class="label">
                        <i class="fal fa-suitcase-rolling"></i>
                        {{$t('checkedBag')}}
                        <span v-if="listing.checkedBaggageTotal > 0">({{ listing.checkedBaggageTotal }})</span>
                      </p>
                      <p class="value">
                        <span v-if="listing.checkedBaggageTotal > 0">{{$t('included')}}</span>
                        <span v-else>{{$t('addAtBook')}}</span>
                      </p>
                    </div>

                    <div class="total">
                      <p>{{$t('total')}}: 
                        <span v-if="listing.travelerPrices.length > 1">({{listing.travelerPrices.length + ' ' + $t('travelers')}})</span>
                        <span v-else>({{listing.travelerPrices.length + ' ' + $t('traveler')}})</span>
                      </p>
                      <p>{{ listing.price.total | formatCurrency(currency, 0) }}</p>
                    </div>
                    
                  </div>
                </template>
              </v-popover>
            </div>
            

            <p class="price">{{ listing.price.total | formatCurrency(currency, 0) }}</p>
            
            <p class="seat-class">{{ $t(listing.seatClass) }}</p>
            
            <router-link :to="{ name: 'FlightsBooking', params: { id: listing.offerToken }}"
              tag="button" 
              class="btn">
                {{ $t('bookNow') }}
            </router-link>

            <div @click="executeAvail(listing)" class="details-toggle" v-if="!showAvailDetails" :class="{open : showAvailDetails}">
              <span v-if="!showAvailLoader">
                <span>{{ $t('flightDetails') }}</span>
                <i class="fal fa-angle-down"></i>
              </span>
              
              <span v-if="showAvailLoader">
                <span>{{ $t('loading') }}</span>
                <i class="fal fa-spinner fa-pulse"></i>
              </span>
            </div>

            <div @click="showAvailDetails = false" v-if="showAvailDetails" class="details-toggle">
              <span>{{ $t('hideDetails') }}</span>

              <i class="fal fa-angle-up"></i>
            </div>

        </div>
      </div>

      <div class="flight-details" v-if="showAvailDetails">
        <div class="bound" v-for="(bound, boundIndex) in listing.availResponse.offer.bounds" :key="boundIndex" v-if="listing.availResponse">
          <div class="title-bar">
            <p class="route">
              <span class="type" v-if="boundIndex == (listing.availResponse.offer.bounds.length - 1)">{{ $t('return') }}</span>
              <span class="type" v-else>{{ $t('outbound') }}</span>
              {{ bound.segments[0].from.iataCode | toCityName }} - {{bound.segments[bound.segments.length - 1].to.iataCode | toCityName}}
            </p>
            <p>
              <span class="time">
                <i class="fal fa-clock"></i> {{ bound.totalTravelTime | parseDuration }}
              </span>
            </p>
          </div>

          <div class="details-block" v-for="(segment, segmentIndex) in bound.segments" :key="segmentIndex">
            <div class="segment-info">
              <div class="date">
                {{ segment.from.date | moment("ddd, MMMM Do") }}
              </div>
              <div class="route">
                <p class="times">
                  {{ [ segment.from.time, "HH:mm" ] | moment("h:mma") }} — {{ [ segment.to.time, "HH:mm" ] | moment("h:mma") }}
                  <span class="trip-time">{{ segment.travelTime | parseDuration }}</span>
                </p>
                <p class="airports">
                  {{segment.from.iataCode | toCityName}} <span class="code">{{ segment.from.iataCode }}</span>
                  - {{segment.to.iataCode | toCityName}} <span class="code">{{ segment.to.iataCode }}</span>
                </p>
              </div>
              <div class="airline">
                <img class="airline-logo" :src="'https://assets.totaltravel.io/img/airlines/' + segment.marketingCarrier.iataCode + '.png'" :alt="segment.marketingCarrier.iataCode | toAirlineName" />
                <div>
                  <p>
                    {{segment.marketingCarrier.iataCode | toAirlineName}} ({{ segment.marketingCarrier.iataCode }})
                    <i class="fal fa-info-circle" 
                      v-if="segment.marketingCarrier.iataCode != segment.operatingCarrier.iataCode" 
                      v-tooltip="$t('operatedBy') + ' ' + segment.operatingCarrier.iataCode"></i>
                  </p>
                  <p>{{ $t('flight') }} #: {{ segment.flight }}</p>
                  <p>{{ $t('class') }}: {{ segment.cabinClass }}</p>
                </div>
              </div>
          </div>

          <div class="segment-separator" v-if="segmentIndex < bound.segments.length - 1">
            <span class="text">
              <span class="background time">
                {{$moment.duration($moment(bound.segments[segmentIndex + 1].from.date + 'T' + bound.segments[segmentIndex + 1].from.time).diff($moment(segment.to.date + 'T' + segment.to.time))) | parseDuration}}
              </span>
              <span class="background">{{ $t('layoverIn') }} {{segment.to.iataCode | toAirportName}} {{ $t('airport') }} ({{segment.to.iataCode}})</span>
            </span>
          </div>

          <div class="segment-separator" v-if="segmentIndex < bound.segments.length - 1 && segment.to.iataCode !== bound.segments[segmentIndex + 1].from.iataCode">
            <span class="text">
              <span class="background">{{ $t('changeAirports') }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import FlightsApi from '../../services/flightsApi'
import { mapGetters } from 'vuex'
import { analytics } from "../../firebaseConfig";

const locationData = require('../../assets/data/locationData');

export default {
  name: 'FlightListing',
  data () {
    return {
      showAvailDetails: false,
      showAvailLoader: false,
      moment: this.$moment
    }
  },

  methods: {

    executeAvail: function(listing) {
      let self = this;

      if (self.getAvailResponse(listing.offerToken)) {
        self.showAvailDetails = true;
      }

      if (!listing.availResponse) {
        self.showAvailLoader = true;
        self.api.availability(listing.offerToken).then((result) => {
          listing.availResponse = result.data;
          self.$store.dispatch('updateAvailResponse', listing.availResponse);
          self.showAvailDetails = true;
          self.showAvailLoader = false;
          analytics.logEvent('availability', {
            agency: window.TravelPlatform.key,
            type: 'flight',
            currency: listing.availResponse.currency,
            origin: listing.availResponse.offer.bounds[0].segments[0].from.iataCode,
            destination: (listing.availResponse.offer.bounds.length > 1)
                ? listing.availResponse.offer.bounds[1].segments[0].from.iataCode
                : listing.availResponse.offer.bounds[0].segments[listing.availResponse.offer.bounds[0].segments.length - 1].to.iataCode
          });
        });
      }
    },

    genericAirlineLogo: function(event) {
        event.target.src = "../assets/img/airlines/*A.png"
    },

    toCityName: function(code) {
      let airport = locationData.airports.find((airport) => airport.code.toLowerCase() === code.toLowerCase());
      if (airport) {
        let city = locationData.cities.find((city) => city.id.toLowerCase() === airport.cityId.toLowerCase());
        if (city) {
          return city.name;
        }
      }

      return code;
    }
  },

  computed: {
    ...mapGetters ([
      'getAvailResponse'
    ]),
    isSafari() {
      let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
      return isSafari;
    }
  },

  mounted () {
    this.api = new FlightsApi();
  },

  props: ['listing', 'currency', 'departureToReturnDays', 'searchOrigin', 'searchDestination']
}
</script>